interface JobInterface {
    job: Job,
    date: JobDate,
    data: any,
    state?: JobState
}

interface JobDate {
    start: Date;
    recurring?: number; // in secounds
    limit?: number;
}

enum Job {
    SMS = "sms",
    EMAIL = "email",
    CONSOLELOG = "consolelog",
    INVOICE_REMINDER = "invoice-reminder",
    SEND_INVOICE = "send-invoice-email",
    BANK_SYNC = "bank-sync",
    BANK_TRANSFER = "bank-transfer",
    BACKUP = "backup",
}

enum JobState {
    COMPLETED = "completed",
    ACTIVE = "active",
    FAILED = "failed"
} 

export { JobInterface, Job }